// extracted by mini-css-extract-plugin
var _1 = "StarRatingButton_rating__snQuz";
var _2 = "StarRatingButton_star__67lOs";
var _3 = "StarRatingButton_starInput__27IMu";
export { _1 as "rating", _2 as "star", _3 as "starInput" }
